import React, { memo } from "react";
import { useIntl } from "react-intl";
import { Map, GeoJSON } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import MapCache from "../MapCache";
import LayerControlMap from "../LayerControlMap";
import "./style.scss";

const AreaMapResult = memo(({ aoiInfo, layers, car_layers, showLegend = false, ...props }) => {
  const { formatMessage } = useIntl();

  const onlyXY = aoiInfo.B3Area.geojson_simplificado.coordinates[0].map(coord => {
    return coord.filter((_, index) => index !== 2);
  })

  const bounds = onlyXY.map(coord =>
    [...coord].reverse()
  );

  return (
    <>
      <Map
        fullscreenControl
        center={aoiInfo.B3Area.geojson_centroid.coordinates.reverse()}
        bounds={bounds}
        maxBounds={bounds}
        {...props}
      >

        <LayerControlMap layers={car_layers} />

        <MapCache />

        <GeoJSON color="#13FFE8" data={aoiInfo.B3Area.geojson_simplificado} />

        {layers &&
          layers.map(layer =>
            layer.layer.features.map((feature, index) => (
              <GeoJSON
                key={`${layer.slug}-${index}`}
                data={feature.geometry}
                {...layer.style}
              />
            ))
          )}
      </Map>

      {showLegend && (
        <div className="area-map-legend">
          <p className="title">{formatMessage({ id: "legenda" })}</p>
          <p>
            <span
              className="legend-color"
              style={{
                backgroundColor: "#13FFE8"
              }}
            ></span>
            {formatMessage({ id: "area-consultada" })}
          </p>
          {layers &&
            layers.map(layer => (
              <p key={layer.slug}>
                <span
                  className="legend-color"
                  style={{
                    backgroundColor: layer.style && layer.style.color
                  }}
                ></span>
                {layer.name}
              </p>
            ))}
        </div>
      )}
    </>
  );
});

export default AreaMapResult;
